<template>
  <app-modal name="move-directory-modal" :title="title" @before-open="beforeOpen" @before-close="beforeClose"  width="30%" @on-ok="onOk">
    <app-form
      ref="form"
      @on-submit="onSubmit"
      :schema="schema"
      :data="formModel"
    />
  </app-modal>

</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/';
import { getDirectoryOptions } from '@/utils/directory';
import { mapActions, mapState } from 'vuex';
import Vue from 'vue';

export default {
  name: 'MoveDirectoryModal',
  components: {
    AppForm,
    AppModal,
  },
  computed: {
    ...mapState([
      'invoiceGlobalSearchParams',
    ]),
  },
  data() {
    return {
      title: this.$t('directory.moveToDir'),
      schema: [
        {
          name: 'parent_id',
          label: this.$t('directory.dir'),
          placeholder: `${this.$t('app.enter')} ${this.$t('directory.dir')}`,
          type: 'select',
          options: getDirectoryOptions(),
        },
      ],
      formModel: {
        parent_id: '',
      },
      invoices: [],
    };
  },
  mounted() {

  },
  methods: {
    ...mapActions(['moveInvoiceToDir', 'getStatistics']),
    onSubmit(formModel) {
      this.moveInvoiceToDir({
        parent_id: formModel.parent_id,
        invoices: this.invoices,
      }).then(() => {
        this.getStatistics({
          ...this.invoiceGlobalSearchParams,
        });
        this.$bus.emit('on-unselect-items');
        this.$bus.emit('on-moved-directory');
        this.$modal.hide('move-directory-modal', { isOk: true });
      });
    },
    onOk() {
      this.$refs.form.submit();
    },
    beforeClose() {
      this.formModel = {
        parent_id: null,
      };
      this.invoices = [];
    },
    beforeOpen(params) {
      Vue.set(this.schema[0], 'options', getDirectoryOptions());
      this.invoices = params.model;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/directory-list/move-directory-modal.vue